import React, { useState } from "react";
import { A, navigate } from "hookrouter";
import { MdAddCircle, MdSearch, MdAdd } from "react-icons/md";
import { FaUser, FaComments, FaSignOutAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import styles from "./Navbar.module.css";
import { AppContext } from "../../contexts/AppContext";
import { useAuth } from "../Auth/AuthHooks";

const NavbarRight = () => {
  const { t } = useTranslation();
  const [dropdown, setDropdown] = React.useState(false);
  const { logout } = useAuth();
  const { setChat } = React.useContext(AppContext);
  return (
    <li style={{ display: "flex", alignItems: "center" }}>
      <div className={styles.button + " " + styles.mobileSearch}>
        <MdSearch />
      </div>
      <button
        className={styles.newButton}
        onClick={() => navigate("/story/new")}
      >
        <MdAdd className={styles.icon} />
        <MdAddCircle className={styles.icon} />{" "}
        <span>{t("navbar.newStory")}</span>
      </button>
      <Search />
      <div className={styles.button} onClick={() => setDropdown(!dropdown)}>
        <FaUser />
      </div>

      {dropdown && (
        <div className={styles.userDropdown} onClick={() => setDropdown(false)}>
          <A href={"/user"}>
            <FaUser />
            My Profile
          </A>
          <a href={null} onClick={() => setChat(true)}>
            <FaComments />
            Chat
          </a>
          <a href={null} onClick={logout}>
            <FaSignOutAlt />
            Logout
          </a>
        </div>
      )}

      {/* <A href="/user" className={styles.button}>
        <MdChatBubble />
      </A> */}
    </li>
  );
};

export default NavbarRight;

const Search = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleInput = (e) => {
    setSearchTerm(e.target.value);
  };

  const submitSearch = (e) => {
    if (searchTerm && e.key === "Enter") {
      navigate(`/browse/text/${searchTerm}`);
    }
  };

  return (
    <div className={styles.searchContainer}>
      <div className={styles.search}>
        <MdSearch className={styles.icon} />
        <input
          type="text"
          name="search"
          placeholder="Search"
          value={searchTerm}
          onChange={handleInput}
          onKeyDown={submitSearch}
        />
      </div>
    </div>
  );
};
